import {
  Box,
  Modal,
  Typography,
  Button,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import ModalContent from "../../../common/components/Modal";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { AssetApi } from "../../../services/netServices";
import { CustomListItem } from "../../checkList/components/ListItem";

interface ExportModalProps {
  open: boolean;
  onClose: () => void;
  sortModel: any[];
  paginationModel: {
    page: number;
    pageSize: number;
  };
  debouncedSearchTerm: string;
  selectedTags: number[];
  selectedCates: number[];
  selectedDepartments: number;
}

export default function ExportModal({
  open,
  onClose,
  sortModel,
  paginationModel,
  debouncedSearchTerm,
  selectedTags,
  selectedCates,
  selectedDepartments,
}: ExportModalProps): JSX.Element {
  const { t } = useTranslation() as any;

  const [year, setYear] = useState<number>(new Date().getFullYear());
  const [month, setMonth] = useState<number>(new Date().getMonth() + 1);
  const [loading, setLoading] = useState(false);

  const years = Array.from(
    { length: 10 },
    (_, i) => new Date().getFullYear() - i
  );
  const months = Array.from({ length: 12 }, (_, i) => i + 1);

  const handleExport = async () => {
    try {
      setLoading(true);

      // Timestamp 0h ngày đầu tháng
      const date = Math.floor(Date.UTC(year, month - 1, 1, 0, 0, 0) / 1000);

      // Lấy token từ localStorage
      const dataLocalStorage = localStorage.getItem("USER");
      const parsedData = JSON.parse(dataLocalStorage ?? "{}");
      const token = parsedData?.User?.token;

      const axiosResponse = await new AssetApi().assetExportPost(date, token, {
        responseType: "blob",
      });
      const blobData = axiosResponse.data;

      // Tạo link download
      const url = window.URL.createObjectURL(blobData as any);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Export_${year}_${month}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.parentNode?.removeChild(link);
      window.URL.revokeObjectURL(url);

      onClose();
    } catch (error) {
      console.log("Export thất bại", error);
    } finally {
      setLoading(false);
    }
  };
  const handleExportFilter = async () => {
    try {
      setLoading(true);
      const date = Math.floor(Date.UTC(year, month - 1, 1, 0, 0, 0) / 1000);
      const sortField = sortModel[0]?.field ?? "";
      const isDescending = sortModel[0]?.sort === "desc";
      const dataLocalStorage = localStorage.getItem("USER");
      const parsedData = JSON.parse(dataLocalStorage ?? "{}");
      const token = parsedData?.User?.token;
      const axiosResponse = await new AssetApi().assetExportByFilterGet(
        paginationModel.page + 1,
        paginationModel.pageSize,
        debouncedSearchTerm,
        selectedTags,
        selectedCates,
        selectedDepartments,
        date,
        sortField,
        isDescending,
        token,
        { responseType: "blob" }
      );
      const blobData = axiosResponse.data;
      const url = window.URL.createObjectURL(blobData as any);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${axiosResponse.headers.filename}`);
      document.body.appendChild(link);
      link.click();
      link.parentNode?.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.log("Export error:", error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Modal open={open} onClose={onClose}>
      <Box>
        <ModalContent onClose={onClose} title={t("34_00_export")} width={600}>
          <CustomListItem
            leftContainerWidth={150}
            text={t("00_04_month")}
            containerStyle={{ marginBottom: "16px" }}
            RightComponent={
              <FormControl fullWidth>
                <Select
                  variant="standard"
                  label={t("00_04_month")}
                  value={month}
                  onChange={(e) => setMonth(Number(e.target.value))}
                >
                  {months.map((m) => (
                    <MenuItem key={m} value={m}>
                      {m}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            }
          />
          <CustomListItem
            leftContainerWidth={150}
            containerStyle={{ marginBottom: "16px" }}
            text={t("00_04_year")}
            RightComponent={
              <FormControl fullWidth>
                <Select
                  variant="standard"
                  label={t("00_04_year")}
                  value={year}
                  onChange={(e) => setYear(Number(e.target.value))}
                >
                  {years.map((y) => (
                    <MenuItem key={y} value={y}>
                      {y}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            }
          />

          <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>
            <Button
              variant="outlined"
              style={{ borderColor: "#e5e5e5", color: "#000" }}
              onClick={onClose}
            >
              {t("00_03_cancel")}
            </Button>
            <Button
              variant="contained"
              onClick={handleExport}
              disabled={loading}
            >
              {t("34_00_export")}
            </Button>
            <Button
              variant="contained"
              onClick={handleExportFilter}
              disabled={loading}
            >
              {t("34_00_export_by_filter")}
            </Button>
          </Box>
        </ModalContent>
      </Box>
    </Modal>
  );
}
